// extracted by mini-css-extract-plugin
module.exports = {"ContentTabs":"ContentTabs-module--ContentTabs--i2PLz"};